import React, { PureComponent } from 'react';
import './Mist.css';

class Mist extends PureComponent {
	render() {
		return (
			<g className="Mist">
				<path fill="#FFFFFF" d="M1.094,4.674c5.12,0.122,10.472,0.178,15.492,1.255c0.455,0.098,0.9,0.229,1.333,0.398
					c0.494,0.193,0.858-0.718,0.044-0.359C15.978,6.843,13.7,7.197,11.614,7.77C8.57,8.607,4.728,9.257,2.132,11.188
					c-1.944,1.447-0.721,2.774,1.145,3.235c5.184,1.277,10.729,0.648,16.003,1.217c0.691,0.074,1.377,0.186,2.032,0.418
					c-0.148-0.053,0.861-0.971-0.297-0.506c-1.523,0.611-3.189,0.912-4.792,1.236c-3.28,0.662-6.774,1.342-10.136,1.287
					c-1.131-0.018-2.368,1.98-0.83,2.006c3.569,0.059,7.225-0.641,10.712-1.318c1.735-0.338,6.877-0.832,7.571-3.008
					c0.883-2.764-6.788-2.377-7.92-2.424c-3.445-0.139-6.902-0.172-10.32-0.688c-0.438-0.066-1.622-0.178-1.951-0.585
					c0.268,0.331-0.406,0.707,0.142,0.356c0.292-0.186,0.618-0.315,0.934-0.452c4.339-1.883,9.109-2.498,13.552-4.054
					c1.627-0.57,3.687-2.381,1.297-3.489c-2.764-1.282-6.57-1.178-9.54-1.387C7.134,2.851,4.528,2.73,1.924,2.668
					C0.791,2.642-0.445,4.638,1.094,4.674L1.094,4.674z"/>
				<path fill="#CCCCCC" d="M22.907,19.326c-5.12-0.123-10.472-0.18-15.492-1.256c-0.455-0.098-0.9-0.229-1.333-0.398
					c-0.494-0.193-0.858,0.719-0.044,0.359c1.985-0.875,4.263-1.229,6.349-1.801c3.044-0.838,6.887-1.488,9.482-3.419
					c1.944-1.447,0.721-2.775-1.145-3.235C15.541,8.299,9.996,8.927,4.722,8.358C4.03,8.284,3.345,8.174,2.689,7.94
					c0.148,0.053-0.861,0.972,0.297,0.507C4.51,7.836,6.176,7.535,7.778,7.211c3.28-0.663,6.774-1.342,10.136-1.288
					c1.131,0.019,2.368-1.981,0.83-2.006c-3.569-0.058-7.225,0.64-10.712,1.319C6.297,5.575,1.155,6.069,0.461,8.244
					c-0.883,2.764,6.788,2.377,7.92,2.423c3.445,0.139,6.902,0.172,10.32,0.688c0.438,0.066,1.622,0.178,1.951,0.585
					c-0.268-0.331,0.406-0.707-0.142-0.356c-0.292,0.186-0.618,0.315-0.934,0.452c-4.339,1.884-9.109,2.497-13.552,4.054
					c-1.627,0.57-3.687,2.381-1.297,3.49c2.764,1.281,6.57,1.178,9.54,1.387c2.599,0.182,5.204,0.303,7.809,0.365
					C23.21,21.357,24.446,19.361,22.907,19.326L22.907,19.326z"/>
			</g>
		);
	}
}

export default Mist;
